import { render } from "./ClientInfo.vue?vue&type=template&id=c119b074&scoped=true"
import script from "./ClientInfo.vue?vue&type=script&lang=js"
export * from "./ClientInfo.vue?vue&type=script&lang=js"

import "./ClientInfo.vue?vue&type=style&index=0&id=c119b074&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c119b074"]])

export default __exports__